<template>
  <div id="app">
    <div class="login_icon"><img src="@/assets/login-icon.png" /></div>
    <h2>{{ $t("title") }}</h2>
    <button
      @click="logout"
      v-if="store.currentComponent === 'dashboard'"
      class="logout_button"
    >
      {{ $t("logout_label") }}
    </button>
    <hr v-if="store.currentComponent === 'dashboard'" />
    <component :is="store.currentComponent"></component>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { store } from "./store";
import loading from "@/components/Loading.vue";

@Component({
  components: {
    loading,
    login: () => import("@/components/Login.vue"),
    dashboard: () => import("@/components/Dashboard.vue"),
  },
})
export default class App extends Vue {
  store: typeof store = store;

  async mounted() {
    try {
      this.init();

      const loginButton = document.querySelector(
        "div#login-panel div.form-box h1.csc-firstHeader",
      );

      if (loginButton && loginButton.parentElement) {
        loginButton.parentElement.removeChild(loginButton);
        const wrapper = document.querySelector(
          "div#login-panel > div.wrapper",
        ) as HTMLElement;
        wrapper!.style.height = "100px";
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
  }

  private async init() {
    try {
      // Check if the user is logged in or not and use appropriate component
      const result = await this.$fetch("/api/users/ping");

      // Show the dashboard, if the user is already logged in
      if (result.status === 200) {
        this.store.currentComponent = "dashboard";
        return;
      }

      this.store.currentComponent = "login";
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
  }

  async logout() {
    try {
      await this.$fetch("/api/users/logout", { method: "post" });

      (this.store.currentComponent = "loading"),
        (this.store.locations = []),
        (this.store.selectedLocation = []),
        (this.store.currentListComponent = "controlBook"),
        (this.store.customerData = {}),
        (this.store.currentAdminComponent = "users-list"),
        (this.store.currentAdminComponentEditCustomer = {});

      this.init();
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
    }
  }
}
</script>

<style lang="scss" scoped>
div.login_icon {
  background-color: #007abf;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
  position: absolute;
  margin-top: 14px;
  margin-left: 10px;

  img {
    width: 35px;
  }
}

h2 {
  margin-bottom: 0;
  padding: 0 10px 0 70px;
  float: left;
}

hr {
  clear: both;
}

button.logout_button {
  float: right;
  background-color: #007abf;
  border: unset;
  height: 30px;
  color: #ffffff;
  margin-right: 10px;
  margin-top: 12px;
  text-transform: uppercase;
  cursor: pointer;
}
</style>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(133, 133, 133);
}

#app * {
  box-sizing: border-box;
}
</style>
